export default __webpack_public_path__ + "static/pragicts-ai-banner-new-possibilities-5231a5cc78d68a6b5dc5dc3dc03ee96d.jpg";